// extracted by mini-css-extract-plugin
module.exports = {"RejectWithdrawal":"RejectWithdrawal_RejectWithdrawal__Rt9KJ","SelectReason":"RejectWithdrawal_SelectReason__2p2Cl"};